"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,0 L3.73855426,0 L3.73855426,4.28765071 C3.73855426,5.03946171 3.85210734,5.56415527 4.07921692,5.86174713 C4.30632649,6.15933899 4.63523887,6.30813268 5.06596393,6.30813268 C5.49668899,6.30813268 5.82951699,6.15933899 6.06445793,5.86174713 C6.29939887,5.56415527 6.41686758,5.03946171 6.41686758,4.28765071 L6.41686758,0 L8.08493991,0 L8.08493991,4.11144588 C8.08493991,5.39578969 7.82846656,6.33162372 7.31551218,6.91897607 C6.80255779,7.50632842 6.05271588,7.80000019 5.06596393,7.80000019 C4.07138062,7.80000019 3.31174964,7.50632842 2.78704821,6.91897607 C2.26234678,6.33162372 2,5.39578969 2,4.11144588 L2,0 Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "9",
    width: "10",
    height: "1"
  })));
};

exports["default"] = _default;